import { Relationship } from '@wellesley/openapi'

export const canFollow = (data: Relationship) =>
  !data?.following || data?.following === 'REJECTED'

export const canUnfollow = (data: Relationship) =>
  data?.following === 'ACCEPTED'

export const canFollowBack = (data: Relationship) =>
  canFollow(data) && data?.followed === 'ACCEPTED'

export const isFollowPending = (data: Relationship) =>
  data?.following === 'PENDING'

export const isFollowing = (data: Relationship) => canUnfollow(data)

export const isBlocked = (data: Relationship) => !!data?.blocked

export const isBlockedBy = (data: Relationship) => !!data?.blockedBy

export const isMuted = (data: Relationship) => !!data?.muted?.state

export const canUnsubscribeFromMe = (data: Relationship) =>
  data?.followed === 'ACCEPTED'
